import { render } from "./ThirdSection.vue?vue&type=template&id=63fd12c0&scoped=true"
import script from "./ThirdSection.vue?vue&type=script&lang=js"
export * from "./ThirdSection.vue?vue&type=script&lang=js"

import "./ThirdSection.vue?vue&type=style&index=0&id=63fd12c0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63fd12c0"]])

export default __exports__